import React, { useState } from "react";
import "./loginPage.scss";
import { toast } from "react-toastify";
import LogoCompo from "../../../components/LogoCompo/LogoCompo";
import AllServices from "../../../Services/AllServices";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../../components/CustomLoader/CustomLoader";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const LoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loginForm, setLoginForm] = useState({
    User_Name: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setLoginForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setLoading(false);
    const dataObj = {
      User_Name: loginForm.User_Name,
      password: loginForm.password,
    };

    try {
      setLoading(true);
      const response = await AllServices.loginAdmin(dataObj);

      if (response.data.success === false) {
        toast.error(response.data.message);
      }

      const token = response.data.token;

      if (token) {
        localStorage.setItem("auth-token", token);
      }

      if (token) {
        var decodeToken = jwtDecode(token);
      }
      const checkRole = decodeToken.role;

      if (response.data.succuss === true) {
        if (checkRole === "ADMIN") {
          toast.success(response.data.message);

          navigate("/adminuser/views", { state: { refresh: true } });
        } else {
          toast.error("You are Unauthorized!");
        }
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="split-login-page">
      {loading && (
        <div className="loader-overlay">
          <CustomLoader />
        </div>
      )}

      {/* Top Header Bar */}
      <header className="portal-header">
        <div className="brand-name">Cinnamon Lakehouse</div>
        <nav className="portal-nav">
          <span className="nav-item active">Portal</span>
          <span
            className="nav-item"
            onClick={() =>
              toast.info("Security Policies are managed centrally.")
            }
          >
            Security
          </span>
          <span
            className="nav-item"
            onClick={() =>
              toast.info("For support, please contact IT Helpdesk.")
            }
          >
            Support
          </span>
        </nav>
      </header>

      {/* Split login container */}
      <main className="split-login-container">
        <div className="login-card">
          {/* Left Column - Hero Section */}
          <div className="login-hero">
            <div className="hero-overlay"></div>
            <div className="hero-content">
              <h1 className="hero-title">Experience Tranquility</h1>
              <p className="hero-description">
                Manage bookings, guest registrations, and services for Cinnamon
                Lakehouse's premier retreat.
              </p>
              <div className="hero-footer">
                <span className="divider-line"></span>
                <span className="established-text">ESTABLISHED 2024</span>
              </div>
            </div>
          </div>

          {/* Right Column - Form Section */}
          <div className="login-form-area">
            <div className="form-inner">
              <div className="logo-wrapper">
                <LogoCompo />
              </div>

              <div className="form-header">
                <h2>Internal Portal</h2>
                <p>Please sign in with your corporate credentials.</p>
              </div>

              <form onSubmit={handleSubmit} className="login-form">
                <div className="form-group">
                  <label htmlFor="User_Name">USER NAME</label>
                  <div className="input-wrapper">
                    <PersonIcon className="field-icon" />
                    <input
                      id="User_Name"
                      type="text"
                      placeholder="Enter username"
                      value={loginForm.User_Name}
                      onChange={handleChange}
                      name="User_Name"
                      required
                      autoComplete="username"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="label-row">
                    <label htmlFor="password">PASSWORD</label>
                    <span
                      className="forgot-link"
                      onClick={() =>
                        toast.info(
                          "Please contact your IT administrator to reset your password.",
                        )
                      }
                    >
                      Forgot Password?
                    </span>
                  </div>
                  <div className="input-wrapper">
                    <LockIcon className="field-icon" />
                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter password"
                      value={loginForm.password}
                      onChange={handleChange}
                      name="password"
                      required
                      autoComplete="current-password"
                    />
                    <button
                      type="button"
                      className="toggle-password-btn"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </button>
                  </div>
                </div>

                <div className="remember-me-row">
                  <label className="checkbox-label">
                    <input type="checkbox" name="remember" />
                    <span>Keep me signed in for 24 hours</span>
                  </label>
                </div>

                <button type="submit" className="submit-btn">
                  LOGIN
                </button>
              </form>

              <div className="form-footer-badge">
                <span className="shield-icon">🛡️</span>
                <span>Secure 256-bit Encrypted Portal</span>
              </div>

              <div className="contact-admin-row">
                <span>Don't have an account? </span>
                <span
                  className="contact-link"
                  onClick={() =>
                    toast.info(
                      "Please contact the primary system administrator.",
                    )
                  }
                >
                  Contact Admin
                </span>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Bottom Footer Bar */}
      <footer className="portal-footer">
        <div className="footer-left">
          <strong>Cinnamon Lakehouse</strong>
          <span className="copyright">
            © 2026 Revolution Tech Software Solutions. All rights reserved.
          </span>
        </div>
        <div className="footer-right">
          <span
            className="footer-link"
            onClick={() =>
              toast.info(
                "Privacy Policy document is available at the front desk.",
              )
            }
          >
            Privacy Policy
          </span>
          <span
            className="footer-link"
            onClick={() =>
              toast.info(
                "Terms of Service details can be requested from administration.",
              )
            }
          >
            Terms of Service
          </span>
          <span
            className="footer-link"
            onClick={() =>
              toast.info(
                "This system is compliant with standard hotel security audits.",
              )
            }
          >
            Security Standards
          </span>
        </div>
      </footer>
    </div>
  );
};

export default LoginPage;
